import {
  getAuthorAcclaimAchievementsByID,
  getAuthorProfileSummaryByID,
  getAuthorHonorsByID,
  getAuthorExperiencesByID
} from "Explore/Services/Author";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./BasicInformation.module.scss";
import BasicInformationLandscape from "./BasicInformationLandscape";
import BasicInformationMobile from "./BasicInformationMobile";
import useExploreInfo from "Hooks/useExploreInfo";
const BasicInformation = ({
  setPublicationVerify,
  setInstitutionId,
  setVideoPresentations,
  setTabDisableInformation,
  setFacultyInfo,
}) => {
  const { entity_id: faculty_id } = useExploreInfo();
  const navigate = useNavigate();
  const [summary, setSummary] = useState({
    data: {},
    isLoading: true,
  });
  const [citationStatistics, setCitationStatistics] = useState({
    data: [],
    isLoading: true,
  });
  const [citationCount, setCitationCount] = useState(null);
  const [acclaimAchievements, setAcclaimAchievements] = useState({
    honors: [],
    honor_awards_source_url: "",
    experiences: [],
    work_experience_source_url: "",
    education: [],
    education_source_url: "",
    isLoading: true,
  });
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setSummary({ ...summary, isLoading: true });
    getAuthorProfileSummaryByID(faculty_id, (res) => {
      if (res?.explore_slug && res.explore_slug !== faculty_id) {
        navigate(`/explore/faculty/${res.explore_slug}`, { replace: true });
      }
      setSummary({ data: res, isLoading: false });
      setFacultyInfo?.({
        name: res?.name || "",
        position: res?.position || "",
        department: res?.department?.[0]?.name || "",
        institution: res?.institution?.name || "",
      });
      const citationByYear = res?.citation_by_year || {};
      const citation_statistic = Object.keys(citationByYear || {}).map(
        (key) => {
          return {
            Year: key,
            Citations: citationByYear[key],
          };
        }
      );
      setCitationStatistics({ data: citation_statistic, isLoading: false });
      setCitationCount(res.citation_count);
      setInstitutionId(res?.institution?.id);
      setVideoPresentations(res.video_presentations);
      setTabDisableInformation({
        has_collaborators: res.has_collaborators,
        has_grants: res.has_grants,
        has_publications: res.has_publications,
      });
    });
    getAuthorAcclaimAchievementsByID(faculty_id, (res) => {
      setAcclaimAchievements({
        honors: res.honor_awards,
        honor_awards_source_url: res.honor_awards_source_url,
        experiences: res.work_experience,
        work_experience_source_url: res.work_experience_source_url,
        education: res.education,
        education_source_url: res.education_source_url,
        isLoading: false,
      });
    });
    getAuthorExperiencesByID(faculty_id, 1, 10, null, (res) => {
      console.log("experiences", res);
    });
  }, [faculty_id]);
  return (
    <div className={styles["basic-information"]}>
      {window.screen.width > 900 ? (
        <BasicInformationLandscape
          summary={summary}
          citationStatistics={citationStatistics}
          citationCount={citationCount}
          acclaimAchievements={acclaimAchievements}
          faculty_id={faculty_id}
        />
      ) : (
        <BasicInformationMobile
          summary={summary}
          citationStatistics={citationStatistics}
          acclaimAchievements={acclaimAchievements}
          faculty_id={faculty_id}
        />
      )}
    </div>
  );
};

export default BasicInformation;
